// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b-table .table[data-v-2ae1d78a]{border:1px solid #ebebeb}.b-table .table .skills-wrapper[data-v-2ae1d78a]{display:flex;align-items:center}.b-table .table .space-between[data-v-2ae1d78a]{justify-content:space-between}.b-table .table .center[data-v-2ae1d78a]{justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
